import * as AuthenticationContext from 'adal-angular';
import { ICommonAuthenticationOptions } from './../components/Globals/Globals';
import { IAuthConfig } from './IAuthConfig';

export interface IAuthenticationResult {
  isOk: boolean;
  user: AuthenticationContext.UserInfo | null;
  error: string;
  authenticationContext?: AuthenticationContext | null;
}

export function authenticate(authenticationContext: AuthenticationContext): IAuthenticationResult {
  authenticationContext.handleWindowCallback();
  const authenticationResult: IAuthenticationResult = {
    isOk: authenticationContext.getCachedUser() && !authenticationContext.getLoginError(),
    user: authenticationContext.getCachedUser(),
    error: authenticationContext.getLoginError(),
    authenticationContext
  };
  if (authenticationResult.error) {
    return authenticationResult;
  }
  if (!authenticationResult.error && !authenticationResult.isOk) {
    authenticationContext.login(); // This will redirect the application
    return authenticationResult;
  } else {
    return authenticationResult;
  }
}

export function makeAuthenticationContext(
  options: AuthenticationContext.Options
): AuthenticationContext {
  return new AuthenticationContext(options);
}

export function mergeAuthenticationOptions(
  commonOptions: ICommonAuthenticationOptions,
  environmentOptions: IAuthConfig
): AuthenticationContext.Options {
  return {
    instance: commonOptions.instance,
    redirectUri: commonOptions.redirectUri,
    ...environmentOptions
  };
}



// WEBPACK FOOTER //
// ./src/authentication/Authentication.ts